<div class="spinner">
  <app-loader></app-loader>
</div>
<h2 mat-dialog-title class="Dialog-box">
  {{DialogText}}
</h2>
<div [formGroup]="shareControl">
  <mat-form-field class="autocomplete">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput placeholder="Enter or search email address here" formControlName="emails" [matAutocomplete]="auto1"
      tabindex="-1" maxlength="100">
      @if (shareControl.controls['emails'].hasError('pattern') && !shareControl.controls['emails'].hasError('required')) {
        <mat-error
          >
          {{ValidationMessages.EMAIL_FORMAT}}
        </mat-error>
      }
      @if (shareControl.controls['emails'].hasError('maxlength')) {
        <mat-error>
          {{ValidationMessages.EMAIL_MAX_LENGTH}}
        </mat-error>
      }
      @if (shareControl.controls['emails'].errors?.emails) {
        <mat-error>
          {{shareControl.controls['email'].errors?.Email}}
        </mat-error>
      }
      <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="emailCall($event)">
        @for (email of (emailsDropdown | async); track email) {
          <mat-option>
            {{email}}
          </mat-option>
        }
        @if (isLoadingEmail && isDataEmail) {
          <mat-option id="loading">Loading</mat-option>
        }
        @if (!isDataEmail && !isLoadingEmail) {
          <mat-option id="noRecord">No Record Found</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <div name="Actions">
      <button mat-button color="primary" (click)="CloseDialog()">Cancel</button>
      <button class="float-right" [disabled]="saveDisableCheck()" mat-flat-button color="primary"
      (click)="send()">Send</button>
    </div>
  </div>